import axios from 'axios'

/**
 * axios 0.19 no soporta `signal`; conecta un AbortSignal con un CancelToken
 * para que al abortar se cancele la petición HTTP en curso.
 * Una petición cancelada se rechaza como `AbortError`.
 */
export async function abortableRequest(signal, request) {
  if (!signal) return request({})
  if (signal.aborted) throw new DOMException('Aborted', 'AbortError')

  const source = axios.CancelToken.source()
  const onAbort = () => source.cancel('Aborted')
  signal.addEventListener('abort', onAbort)
  try {
    return await request({ cancelToken: source.token })
  } catch (error) {
    if (axios.isCancel(error)) throw new DOMException('Aborted', 'AbortError')
    throw error
  } finally {
    signal.removeEventListener('abort', onAbort)
  }
}
